import { render, staticRenderFns } from "./JiGuiZu.vue?vue&type=template&id=30bccf90&scoped=true&"
import script from "./JiGuiZu.vue?vue&type=script&lang=js&"
export * from "./JiGuiZu.vue?vue&type=script&lang=js&"
import style0 from "./JiGuiZu.vue?vue&type=style&index=0&id=30bccf90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bccf90",
  null
  
)

export default component.exports